export const WASTE_FORM_TYPE = {
  "BALED": "Baled",
  "LOOSE": "Loose"
}

export const WasteFormType = {
  "Baled": "Bel.",
  "Loose": "Luz"
}

// export const WasteFormBadges = {
//   "ContainerExchange": "teal",
//   "Loading": "fiolet"
// }
